import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Configurator from "./components/Configurator";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

const Home = () => (
  <main className="bg-[#0A0A0A] font-[Outfit] text-[#F7F5F0]" data-testid="home-page">
    <Header />
    <Hero />
    <Configurator />
    <Services />
    <Portfolio />
    <Process />
    <Testimonials />
    <FAQ />
    <Contact />
    <FloatingWhatsApp />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
